// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1vzBL","title":"styles_title__16MPB"};